import { Skeleton } from '@mantine/core';
import { Fragment } from 'react/jsx-runtime';
import { useProcessAnalysisStore } from '../../../store/process-analysis-store/process-analysis-store';
import { useAssessmentViewData, useWorkPeriodGoals } from './assessment-view.hooks';
import { SectionDelivery } from './section-delivery';
import { SectionGoals } from './section-goals';
import { SectionKeyMeasures } from './section-key-measures';
import { SectionPace } from './section-pace';
import { SectionPhase } from './section-phase';

export const AssessmentView = () => {
  const { scoreData, keyMeasuresData, flowData, isFetchingScoreData, isFetchingKeyMeasuresData, isFetchingFlowData } =
    useAssessmentViewData();
  const workPeriod = useProcessAnalysisStore((state) => state.workPeriod);
  const { data: goals } = useWorkPeriodGoals({ workPeriodId: workPeriod?.id });

  const score = scoreData?.health_scores?.score_by_points || 0;

  return (
    <Fragment>
      {isFetchingScoreData || isFetchingKeyMeasuresData ? (
        <Skeleton height={200} radius="md" mb="md" style={{ minHeight: 200 }} />
      ) : (
        <SectionKeyMeasures score={score} data={keyMeasuresData} />
      )}
      {workPeriod && goals && goals.length ? <SectionGoals workPeriodId={workPeriod.id} /> : null}
      {isFetchingFlowData ? (
        <>
          <Skeleton height={500} radius="md" mb="md" style={{ minHeight: 500 }} />
          <Skeleton height={500} radius="md" mb="md" style={{ minHeight: 500 }} />
          <Skeleton height={500} radius="md" mb="md" style={{ minHeight: 500 }} />
        </>
      ) : (
        flowData && (
          <>
            <SectionPhase data={{ flow_by_phase: flowData.flow_by_phase, flow_by_pace: flowData.flow_by_pace }} />
            <SectionPace data={flowData.flow_by_pace} />
            <SectionDelivery data={{ burns: flowData.burns, historical_burns: flowData.historical_burns }} />
          </>
        )
      )}
    </Fragment>
  );
};
